import React from 'react';
import { Link } from 'react-router-dom';
import { UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Button, Layout, Menu } from 'antd';
const { Sider } = Layout;
const { SubMenu } = Menu
import { checkMobile } from '../../comonFunction/utils'
const isMobile = checkMobile()

class SiderSection extends React.Component {
    constructor(props){
        super(props)
    }
    state = {
        isMobile: '',
        current_option: '2'
    }
    componentDidMount(){
    }
    render(){
        this.state.isMobile = (isMobile==1)?'block':'none';
        return(
            <Sider
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={(broken) => {
                    //console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                    //console.log(collapsed, type);
                }}
                // trigger={
                //     <Button>hi</Button>
                // }
                style={{display: this.state.isMobile}}
            >
                <div className="logo" ></div>
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[this.state.current_option]}
                >
                    {this.props.menuSider.map((menu, index) => {
                        if(this.props.logedIn == true && menu.logedIn == 1){
                            if(menu.subMenu){
                                return(
                                    <SubMenu
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        onTitleClick={(e)=>{
                                            e.domEvent.stopPropagation()
                                        }}
                                    >
                                        {menu.subMenu.map((submenu, index) => {
                                            return(
                                                <Menu.Item key={submenu.link}>
                                                    <Link to={submenu.link}>{submenu.title}</Link>
                                                </Menu.Item>
                                            )
                                        })}
                                    </SubMenu>
                                )
                            }else{
                                return(
                                    <Menu.Item
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        style={{marginLeft: '5px'}}
                                        onClick={(menu.title == 'Log Out')? this.props.logout:''}
                                    >
                                        <Link to={menu.link}>{menu.title}</Link>
                                    </Menu.Item>
                                )
                            }
                        }else if(this.props.logedIn == false && menu.logedIn == 0){
                            if(menu.subMenu){
                                return(
                                    <SubMenu
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        onTitleClick={(e)=>{
                                            e.domEvent.stopPropagation()
                                        }}
                                    >
                                        {menu.subMenu.map((submenu, index) => {
                                            return(
                                                <Menu.Item key={submenu.link}>
                                                    <Link to={submenu.link}>{submenu.title}</Link>
                                                </Menu.Item>
                                            )
                                        })}
                                    </SubMenu>
                                )
                            }else{
                                return(
                                    <Menu.Item
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        style={{marginLeft: '5px'}}
                                    >
                                        <Link to={menu.link}>{menu.title}</Link>
                                    </Menu.Item>
                                )
                            }
                        }else if(menu.logedIn == 2){
                            if(menu.subMenu){
                                return(
                                    <SubMenu
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        onTitleClick={(e)=>{
                                            e.domEvent.stopPropagation()
                                        }}
                                    >
                                        {menu.subMenu.map((submenu, index) => {
                                            return(
                                                <Menu.Item key={submenu.link}>
                                                    <Link to={submenu.link}>{submenu.title}</Link>
                                                </Menu.Item>
                                            )
                                        })}
                                    </SubMenu>
                                )
                            }else{
                                return(
                                    <Menu.Item
                                        key={menu.link}
                                        icon={menu.icon}
                                        title={menu.title}
                                        style={{marginLeft: '5px'}}
                                    >
                                        <Link to={menu.link}>{menu.title}</Link>
                                    </Menu.Item>
                                )
                            }
                        }
                    })}
                </Menu>
            </Sider>
        )
    }
}

export default SiderSection;